export const BRAND = {
  LOGO_SRC: '/logo.png',
  LOGO_ALT: 'PRO20',
  LOGIN_DASHBOARD_PREVIEW_SRC: '/assets/images/login-dashboard-preview.png',
  TAB_SCREENSHOT_1_SRC: '/assets/images/tab_screenshot1.png',
  TAB_SCREENSHOT_2_SRC: '/assets/images/tab_screenshot2.png',
  DASHBOARD_IPAD_SRC: '/assets/images/screenshots/dashboard_ipad.png',
  DASHBOARD_IPHONE_SRC: '/assets/images/screenshots/dashboard_iphone.png',
  CHAT_SCREENSHOT_SRC: '/assets/images/screenshots/chat.png',
  /** Branch code for marketing Privacy Policy (pro20.net/informativaprivacy/:code) */
  PRIVACY_INFORMATIVA_BRANCH_CODE: 'B09B323C7B',
} as const;
